import { render, staticRenderFns } from "./TagReportCard.vue?vue&type=template&id=ca6a2aaa&scoped=true&"
import script from "./TagReportCard.vue?vue&type=script&lang=js&"
export * from "./TagReportCard.vue?vue&type=script&lang=js&"
import style0 from "./TagReportCard.vue?vue&type=style&index=0&id=ca6a2aaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6a2aaa",
  null
  
)

export default component.exports